import { createContext } from "react";
const ColumnsContext = createContext({
  collapseMobile: false,
  collapseTablet: false,
  collapseDesktop: false,
  mobileSpace: "none",
  tabletSpace: "none",
  desktopSpace: "none",
  wideSpace: "none",
  align: "left",
  component: "div"
});
export {
  ColumnsContext
};
